import React from 'react';
import TabContainer from '../../components/TabContainer';
import { useAuth } from '../../auth/AuthProvider';
import { PERMISSIONS, hasPermission } from '../../auth/permissions';
import KarZararAnalizPage from '../analiz/KarZararAnalizPage';
import MenuKarliligiPage from '../analiz/MenuKarliligiPage';
import StokUretimAnalizPage from '../analiz/StokUretimAnalizPage';
import ZayiRaporuPage from '../raporlar/ZayiRaporuPage';
import ERPRapor from '../raporlar/KullaniciHareketRaporuPage';

import TuketimAnalizRaporuPage from '../raporlar/TuketimAnalizRaporuPage';
import LogoTransferMutabakatPage from '../raporlar/LogoTransferMutabakatPage';

// import SayimKaybiRaporuPage from '../raporlar/SayimKaybiRaporuPage';     
// { id: 'sayim-kaybi', label: 'Sayım Kaybı Raporu', icon: '⚖️', component: <SayimKaybiRaporuPage /> },
import AlissizTuketilenPage from '../raporlar/AlissizTuketilenPage';
import SktBozulmaPage from '../raporlar/SktBozulmaPage';
import AbcAnalizPage from '../stok/AbcAnalizPage';
import YatirimFizibilitePage from '../raporlar/YatirimFizibilitePage';
import StokDevirRaporuPage from '../raporlar/StokDevirRaporuPage';
import MusteriYorumlariPage from '../raporlar/MusteriYorumlariPage';
import { FcGoogle } from 'react-icons/fc';

// NOT: Satınalma tab'ı kaldırıldı — supplier-performance ve monthly-summary
// endpoint'leri boş (Siparis tablosu kullanılmıyor). Veri akışı kurulunca
// geri eklenebilir. Sayfa dosyası ve /analiz/satinalma route'u korundu.

const RaporlarGroupPage = () => {
  const { user } = useAuth();
  const canViewFeasibility = hasPermission(
    user?.role,
    PERMISSIONS.VIEW_FEASIBILITY,
    user?.effectivePermissions,
  );
  // SKT/Bozulma stok-analitik bir rapor — diğer stok raporları gibi guard'lı
  // (backend RBAC: VIEW_ANALYTICS_STOK_URETIM | VIEW_STOCK; sekme de aynı izinle gösterilir).
  const canViewSkt = !!user && (
    hasPermission(user.role, PERMISSIONS.VIEW_ANALYTICS_STOK_URETIM, user.effectivePermissions) ||
    hasPermission(user.role, PERMISSIONS.VIEW_STOCK, user.effectivePermissions)
  );
  // Alışsız Tüketilen denetim raporu — backend RBAC: MANAGE_SETTINGS | VIEW_ANALYTICS_STOK_URETIM
  const canViewAlissiz = !!user && (
    hasPermission(user.role, PERMISSIONS.VIEW_ANALYTICS_STOK_URETIM, user.effectivePermissions) ||
    hasPermission(user.role, PERMISSIONS.MANAGE_SETTINGS, user.effectivePermissions)
  );

  const tabs = [
    { id: 'kar-zarar', label: 'Kâr / Zarar', icon: '📊', component: <KarZararAnalizPage embedded /> },
    { id: 'satis', label: 'Satış & Menü', icon: '💰', component: <MenuKarliligiPage embedded /> },
    { id: 'stok-uretim', label: 'Stok & Üretim', icon: '📦', component: <StokUretimAnalizPage embedded /> },
    { id: 'zayi-raporu', label: 'Zayi / Fire Raporu', icon: '🗑️', component: <ZayiRaporuPage /> },
    { id: 'tuketim-analiz-raporu', label: 'Tüketim Analiz Raporu', icon: '📋', component: <TuketimAnalizRaporuPage /> },

        { id: 'logo-transfer-mutabakat', label: 'LOGO Mutabakat Raporu', icon: '📋', component: <LogoTransferMutabakatPage /> },
    
    { id: 'stok-devir-raporu', label: 'Stok Devir Raporu', icon: '📋', component: <StokDevirRaporuPage /> },
    { id: 'ERP-Raporu', label: 'ERP Kullanım Raporu', icon: '🕰', component: <ERPRapor /> },
    ...(['yonetim', 'admin'].includes(user?.role) ? [{
      id: 'musteri-yorumlari',
      label: 'Müşteri Yorumları',
      icon: <FcGoogle size={20} />,
      component: <MusteriYorumlariPage />
    }] : []),
    ...(canViewAlissiz ? [{ id: 'alissiz-tuketilen', label: 'Alışsız Tüketilen', icon: '🚨', component: <AlissizTuketilenPage /> }] : []),
    ...(canViewSkt ? [{ id: 'skt-bozulma', label: 'SKT / Bozulma', icon: '⏳', component: <SktBozulmaPage /> }] : []),
    { id: 'abc-analiz', label: 'ABC Analiz', icon: '📈', component: <AbcAnalizPage /> },
    ...(canViewFeasibility
      ? [
          {
            id: 'yatirim-fizibilite',
            label: 'Yatırım Fizibilite',
            icon: '💡',
            component: <YatirimFizibilitePage embedded />,
          },
        ]
      : []),
  ];
  return <TabContainer title="Raporlar" tabs={tabs} defaultTab="kar-zarar" />;
};

export default RaporlarGroupPage;
